export default __webpack_public_path__ + "static/media/wind-default.125df1ec.png";